import lottie from 'lottie-web';
import animationData from '../json/INTERNET_LOOP_MONTAGE_02_2.json';
const scrollToElement = require('scroll-to-element');

export const initHomeHeader = () => {
  var elem = document.getElementById('lottie')
  var animData = {
    container: elem,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    rendererSettings: {
      progressiveLoad:false,
    },
    animationData
  }

  const anim = lottie.loadAnimation(animData)
  anim.play()

  scrollDown()
}


const scrollDown = () => {
  const btn = document.querySelector('.icon-scrolldown')
  if (!btn)
    return

  const textVisual = document.querySelector('.text-visual')
  if (!textVisual)
    return

  btn.addEventListener('click', () => {
    scrollToElement(textVisual, {
      offset: -108,
      ease: 'in-out-quad',
      duration: 500
    })
  })
}
